import { render, staticRenderFns } from "./OperationsMain.vue?vue&type=template&id=32b6cab0"
import script from "./OperationsMain.vue?vue&type=script&lang=js"
export * from "./OperationsMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports